import { useState } from "react";

import { Loader2 } from "lucide-react";

import { Button } from "../../components/ui/button";
import {
  Card,
  CardContent,
  CardFooter,
  CardHeader,
  CardTitle,
} from "../../components/ui/card";
import { ScrollArea } from "../../components/ui/scroll-area";
import {
  Tabs,
  TabsContent,
  TabsList,
  TabsTrigger,
} from "../../components/ui/tabs";

import ProjectBasics from "./ProjectBasics";
import ProjectEnvironment from "./ProjectEnvironment";
import ProjectSystems from "./ProjectSystems";
import ProjectAdmin from "./ProjectAdmin";

const ProjectPropertiesTabs = ({
  properties,
  setProperties,
  onUpdate,
  isUpdating,
}) => {
  const [activeTab, setActiveTab] = useState("project-basics");

  return (
    <>
      <Card className="h-full">
        <CardHeader>
          <CardTitle>Project Properties</CardTitle>
        </CardHeader>

        <CardContent>
          <Tabs value={activeTab} onValueChange={setActiveTab}>
            <TabsList className="w-full flex justify-center">
              <TabsTrigger
                value="project-basics"
                className="flex-grow text-center"
              >
                Project Basics
              </TabsTrigger>

              <TabsTrigger
                value="operating-environment"
                className="flex-grow text-center"
              >
                Operating Environment
              </TabsTrigger>

              <TabsTrigger
                value="system-basics"
                className="flex-grow text-center"
              >
                System Basics
              </TabsTrigger>

              <TabsTrigger
                value="project-admin"
                className="flex-grow text-center"
              >
                Project Admin
              </TabsTrigger>
            </TabsList>

            <ScrollArea className="mt-4">
              <TabsContent value="project-basics">
                <ProjectBasics
                  properties={properties}
                  setProperties={setProperties}
                />
              </TabsContent>

              <TabsContent value="operating-environment">
                <ProjectEnvironment
                  properties={properties}
                  setProperties={setProperties}
                />
              </TabsContent>

              <TabsContent value="system-basics">
                <ProjectSystems
                  properties={properties}
                  setProperties={setProperties}
                />
              </TabsContent>

              <TabsContent value="project-admin">
                <ProjectAdmin
                  properties={properties}
                  setProperties={setProperties}
                />
              </TabsContent>
            </ScrollArea>
          </Tabs>
        </CardContent>

        <CardFooter className="mx-auto mt-4">
          <div className="w-full">
            <div className="flex justify-end">
              <Button
                className="min-w-[120px]"
                onClick={onUpdate}
                disabled={isUpdating || !properties.projectDescription}
              >
                {isUpdating ? (
                  <>
                    <Loader2 className="mr-2 h-4 w-4 animate-spin" />
                    <span>Saving...</span>
                  </>
                ) : (
                  <>
                    <span>Save</span>
                  </>
                )}
              </Button>
            </div>
          </div>
        </CardFooter>
      </Card>
    </>
  );
};

export default ProjectPropertiesTabs;
